/**
 * Hook to detect if player-only mode should be activated.
 * Player-only mode hides the navigation header when ?playeronly=true is in the URL.
 * 
 * @returns true if player-only mode should be active, false otherwise
 */
export default function usePlayerOnlyMode(): boolean {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('playeronly') === 'true';
  } catch {
    return false;
  }
}

